import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as mc_questionAPI from 'api/mc_question';
import * as mc_questionTypes from 'types/mc_question';

// ----------------------------------------------------------------------

type schoolBaseActivity = {
  loading: boolean;
  qaFullList: {
    [level_id: string]: {
      // 每个面板使用 level_id 唯一标识
      rows: any[];
      loading: boolean;
      error: string | null;
    };
  };

  // addPage: { stepperForm1: {}; stepperForm2: {} };
  // addResId: string;
  // courseList: { rows: any[]; total: number };
  // courseLevelPanelList: { rows: any[]; total: number };
};

const initialState: schoolBaseActivity = {
  loading: false,
  qaFullList: {}
  // addPage: { stepperForm1: {}, stepperForm2: {} },
  // addResId: '',
  // courseList: { rows: [], total: -1 },
  // courseLevelPanelList: { rows: [], total: -1 }
};

const slice = createSlice({
  name: 'mc_question',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },

    setPanelData(state, action) {
      const { level_id, rows } = action.payload;
      state.qaFullList[level_id] = {
        rows,
        loading: false,
        error: null
      };
    },
    setPanelLoading(state, action) {
      const { level_id } = action.payload;
      if (!state.qaFullList[level_id]) {
        state.qaFullList[level_id] = {
          rows: [],
          loading: true,
          error: null
        };
      } else {
        state.qaFullList[level_id].loading = true; // 设置该面板为加载状态
      }
    },
    setPanelError(state, action) {
      const { level_id, error } = action.payload;
      if (state.qaFullList[level_id]) {
        state.qaFullList[level_id].loading = false;
        state.qaFullList[level_id].error = error;
      }
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
// export const { startLoading, setStepperFormData } = slice.actions;

// action

// 获取面板数据 (QA full list)
export function get_qa_full_list(params: mc_questionTypes.get_qa_full_list_params) {
  return async () => {
    const { level_id, callback } = params;
    dispatch(slice.actions.setPanelLoading({ level_id })); // 设置面板加载中
    try {
      const response = await mc_questionAPI.get_qa_full_list(params);
      console.log(response);

      dispatch(slice.actions.setPanelData({ level_id, rows: response }));

      if (callback) {
        callback(response);
      }

      // dispatch(slice.actions.setAddResId(response));
    } catch (error: any) {
      dispatch(slice.actions.setPanelError({ level_id, error: error.message }));
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 獲取新增校本課程題目
export function get_mc_answer_options(params: mc_questionTypes.get_mc_answer_options_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, question_id } = params;
    try {
      const response = await mc_questionAPI.get_mc_answer_options({ question_id });
      console.log(response);

      if (callback) {
        callback(response);
      }

      // dispatch(slice.actions.setCourseLevelPanel(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}
